import { useMemo } from "react";
import {useAppSelector} from "hooks/useAppSelector";

export const msgTypeIds = [1, 4];

export const useStationMessage = () => {
    const messageList = useAppSelector((state) => state.message.messageCount);
    const { messageTotalCount, activeKey } = useMemo(() => {
        const messageDict = messageList.reduce((pre, cur) => {
            if (!pre[cur.msgtype]) pre[cur.msgtype] = 0;
            pre[cur.msgtype] += cur.count;
            return pre;
        }, Object.create(null));
        const [systemTypeId, activityTypeId] = msgTypeIds;
        const systemCount = messageDict[systemTypeId] || 0;
        const activityCount = messageDict[activityTypeId] || 0;
        let activeKey = systemTypeId;
        if (systemCount === 0 && activityCount > 0) {
            activeKey = activityTypeId;
        }
        return { messageTotalCount: systemCount + activityCount, activeKey };
    }, [messageList]);

    return {
        messageTotalCount,
    };
};
